import { css, Theme } from "@emotion/react";

export const MPromotionDetailStyle = {
  self: css`
    div,
    span,
    p {
      font-size: 16px !important;
    }

    img {
      width: 100% !important;
      object-fit: contain;
    }

    table {
      width: calc(100vw - 32px) !important;
      margin: 0 !important;
    }
  `,
  btnSubscribe: ({ colors }: Theme) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    button {
      width: 100px;
      height: 36px;
      color: ${colors.white};
      background-color: #2d7699;
      font-size: 14px;
      font-weight: 500;
      &:hover {
        color: ${colors.white} !important;
        background-color: #2d7699 !important;
      }
    }
  `,
};
